import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import {
  Action,
  ACTION_VARIANTS,
  Icon,
  ICON_NAMES,
} from '@reverse-hr/design-system';

const Rider = ({
  modifier = '',
  jobId = undefined,
  candidateId = undefined,
  jobTitle,
  name,
  infos = [],
  showLink = true,
}) => {
  const wrapperClassName = classNames('c-app-rider', modifier);
  const candidateDetailsLink = `/jobs/${jobId}/candidates/${candidateId}`;

  return (
    <div className={wrapperClassName}>
      <div className="c-app-rider__intro">
        <RiderCandidateName
          isIconVisible
          name={name}
          showLink={showLink}
          candidateDetailsLink={candidateDetailsLink}
        />

        <p className="c-app-rider__job-title">{jobTitle}</p>
      </div>

      {infos.length > 0 && (
        <div className="c-app-rider__info">
          {infos.map((info, index) => (
            <p className="c-app-rider__info-item" key={index}>
              <Icon
                className="c-app-rider__info-icon"
                name={info.icon}
                size={16}
              />
              {info.label}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

const RiderCandidateName = ({
  isIconVisible,
  name,
  showLink,
  candidateDetailsLink,
}) => {
  if (showLink) {
    return (
      <NavLink to={candidateDetailsLink} className="c-app-rider__link">
        <Action
          rightIcon={isIconVisible && ICON_NAMES.CHEVRON_BIG_RIGHT}
          variant={ACTION_VARIANTS.SIMPLE_TEXT}
        >
          {name}
        </Action>
      </NavLink>
    );
  }

  return <p className="c-app-rider__name">{name}</p>;
};

export default Rider;
